export default __webpack_public_path__ + "static/media/va2018.32ede59c.jpg";